function init_rates(form, place_creator) {

    let rates = new Rates();

    rates.createPdf('#rates_form');

    //====== CREATE NEW PLACE =======/

    $('body').on('click', '#place_creator', function () {
        calculate.createNewPlace(createCallback);
    });

    let createCallback = function(data) {
        ks_schema
        let fields = Object.keys(data.clientValidate.fields);
        let form = data.clientValidate.form;
        let lower_form = form.toLowerCase();
        let place_index = data.clientValidate.index - 1;

        //Client validate
        fields.forEach(function (field) {
            $('#rates_form').yiiActiveForm('add',{
                id: lower_form + '-places-' + place_index + '-' + field,
                name: form + '[places][' + place_index + ']' + field,
                input: '#' + lower_form + '-places-' + place_index + '-' + field,
                container: '.field-' + lower_form + '-places-' + place_index + '-' + field,
                error: '.help-block',
                validate:  function (attribute, value, messages) {
                    yii.validation.required(value, messages, {
                        message: 'Необходимо заполнить.'
                    })
                }
            })
        });
    };

}